// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_defended_enterprises-module__button--1kmUy{margin-top:32px;text-align:center}\n", ""]);
// Exports
exports.locals = {
	"button": "entity_defended_enterprises-module__button--1kmUy"
};
module.exports = exports;
